import styled from 'styled-components'

import Label from '~/truck/label'

export const Text = styled(Label)`
  margin-left: ${props => props.theme.spacing.comfortable}px;
`
